// API Configuration for connecting to the backend
// This file looks for config in multiple places to support different environments

// Get the base API URL from different possible sources
export const getApiBaseUrl = () => {
  // 1. Check for runtime config from window.ENV (set by Docker)
  if (window.ENV && window.ENV.API_URL) {
    return window.ENV.API_URL;
  }
  
  // 2. Check for Vite environment variables
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  
  // 3. Check for Azure Static Web Apps backend routing
  // Azure SWA connects to backend via /api path by default
  if (window.location.hostname.includes('azurestaticapps.net') || 
      window.location.hostname.includes('azurewebsites.net') ||
      window.location.hostname === 'membasuite.com') {
    return '/api';
  }
  
  // 4. Default fallback for development
  return 'http://localhost:5000';
};

// Create axios instance or fetch wrapper with the correct base URL
const apiConfig = {
  baseURL: getApiBaseUrl(),
  // Add any other API configuration here
};

export default apiConfig;